import React, { useState } from "react";
import { Col, Row } from "react-bootstrap";
import { Link } from "react-router-dom";
import { useSelector } from "react-redux";
import { MenuDown, X } from "react-bootstrap-icons";
import AdminLogin from "../admin/forms/AdminLoginForm";
import Sidebar from "../../Components/Sidebar";

const AdminDashboard = ({ children }) => {
  const { is_staff } = useSelector((state) => state.user?.user ?? false);
  const [sidebarOpen, setSidebarOpen] = useState(false);

  const toggleSidebar = () => setSidebarOpen(!sidebarOpen);

  //   const [dropdowns, setDropdowns] = useState({});

  //   const toggleDropdown = (id) => {
  //     setDropdowns((prev) => ({
  //       ...prev,
  //       [id]: !prev[id],
  //     }));
  //   };

  return (
    <>
      {is_staff ? (
        <div className="container-fluid">
          {/* Mobile Toggle Button */}
          <button
            className={`btn btn-dark toggle_sidebar_btn d-md-none position-fixed mt-2 z-3 ${
              sidebarOpen ? "end-0 me-2" : "start-0 ms-2"
            }`}
            onClick={toggleSidebar}
          >
            {sidebarOpen ? <X size={24} /> : <MenuDown size={24} />}
          </button>
          <Row>
            <Sidebar sidebarOpen={sidebarOpen} title={"Navigation"}>
              <li className="nav-item">
                <Link
                  className="nav-link"
                  to={"/admin/categories"}
                  //   onClick={(e) => {
                  //     e.preventDefault();
                  //     toggleDropdown("sports");
                  //   }}
                >
                  Categories
                </Link>
              </li>

              <li className="nav-item">
                <Link className="nav-link" to={"/admin/products"}>
                  Products
                </Link>
              </li>
              <li className="nav-item">
                <Link className="nav-link" to={"/admin/customers"}>
                  Customers
                </Link>
              </li>
              <li className="nav-item">
                <Link className="nav-link" to={"/admin/orders"}>
                  Orders
                </Link>
              </li>
              <li className="nav-item">
                <Link className="nav-link" to={"/admin/campaign"}>
                  Campaign
                </Link>
              </li>
            </Sidebar>

            {/* main content */}
            <Col md={10} className="main_content adminPage">
              {children ?? <h3>TCF Store Dashboard</h3>}
            </Col>
          </Row>
        </div>
      ) : (
        <AdminLogin />
      )}
    </>
  );
};

export default AdminDashboard;
